module.exports = __webpack_public_path__ + "img/62fa994.png";